export const iconHtml = () => {
  return `
    <div
      style="
        border: 2px solid #2A71D4;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <span
        style="
          display: block;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          background-color: #2A71D4;
          border: 2px solid transparent;
        "
      ></span>
    </div>
  `
}
